/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_CaptureInputs */

const en_inbound_waiting_on_capture = /** @type {(inputs: Inbound_Waiting_On_CaptureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Logistics · packing list · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Logistics · packing list · since {since}" |
*
* @param {Inbound_Waiting_On_CaptureInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_capture = /** @type {((inputs: Inbound_Waiting_On_CaptureInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_CaptureInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_capture(inputs)
});